import FormSelectField from "../../forms/fields/basic/SelectField";
import ConnectionFormDialog from "../../forms/ConnectionFormDialog";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import renderPersonSelection from "../../entitiesReferences/SelectionModals/PersonSelectionModal";
import { ConnectionFormDataController } from "../../../controllers/formController";
import { Person } from "../../../types/person";
import {
  SystemPlaceOfPersonTypes,
  SYSTEM_PLACE_OF_PERSON_TYPE_LABELS,
  PlaceOfPerson,
} from "../../../types/placeOfPerson";
import { Place } from "../../../types/place";
import renderPlaceSelection from "../../entitiesReferences/SelectionModals/PlaceSelectionModal";

interface PlaceOfPersonDialogProps {
  controller: ConnectionFormDataController<PlaceOfPerson, Person, Place>;
}

const PlaceOfPersonDialog: React.FC<PlaceOfPersonDialogProps> = ({
  controller,
}) => {
  return (
    <ConnectionFormDialog<PlaceOfPerson, Person, Place>
      fromLabel="Person"
      fromEntityCollection={SystemEntityCollections.PERSON}
      toLabel="Place"
      toEntityCollection={SystemEntityCollections.PLACE}
      renderFromEntitySelection={renderPersonSelection}
      renderToEntitySelection={renderPlaceSelection}
      controller={controller}
    >
      <FormSelectField
        name="system_place_of_person_type"
        placeholder="Select connection type"
        label="Connection Type"
        options={Object.values(SystemPlaceOfPersonTypes).map((item) => ({
          value: item,
          label: SYSTEM_PLACE_OF_PERSON_TYPE_LABELS[item],
        }))}
        required
      />
    </ConnectionFormDialog>
  );
};

export default PlaceOfPersonDialog;
